import { useRef } from 'react';
import { Box, Button, NavigationDrawer, Overlay } from '@alf/uikit';
import { useFixScroll } from '@namespace/common';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

export const FilterDrawer = ({
  onToggle,
  children = null,
  title,
  onResetClick = () => {},
  onApplyClick = () => {},
  wasFilterChanged,
  isFilterFilled,
  filterId,
  isOpen
}) => {
  const containerRef = useRef(null);
  useFixScroll(`${filterId}CasinoSearchFilterDropdown`, containerRef, isOpen);

  const { t } = useI18n();
  return isOpen ? (
    <Overlay
      classNames={{
        wrapperClass: styles.overlayWrapper
      }}
    >
      <NavigationDrawer
        ref={containerRef}
        title={title}
        onClose={onToggle}
        classNames={{
          wrapper: styles.drawerWrapper,
          title: styles.drawerTitle,
          footer: styles.drawerFooterWrapper,
          close: styles.closeIcon
        }}
        body={children}
        footer={
          <Box className={styles.drawerFooterContainer}>
            <Button
              intent="secondary"
              className={styles.drawerFooterButton}
              onClick={onResetClick}
              disabled={!isFilterFilled}
            >
              {t('web.games.search.filters.reset')}
            </Button>
            <Button
              className={styles.drawerFooterButton}
              onClick={onApplyClick}
              disabled={!wasFilterChanged}
            >
              {t('web.games.search.filters.apply')}
            </Button>
          </Box>
        }
        icon={
          <Icon
            name="icons/general/action/close"
            size="s"
            color="txt_color_4"
          />
        }
      />
    </Overlay>
  ) : null;
};
